import react from 'react'; // eslint-disable-line
import { graphql, useStaticQuery } from 'gatsby';
import { Article } from '../gatsby/types/article';

export type AllPages = {
  allStrapiBlogArticle: {
    edges: {
      node: Article;
    }[]
  }
}

export const useStrapiBlogArticles = (
): Article[] => {
  const { allStrapiBlogArticle } = useStaticQuery<AllPages>(graphql`
    query {
      allStrapiBlogArticle(filter: {
        articleSettings: {publishStatus: {eq: true}},
        seoSettings: {metaIndex: {eq: "index"}},
      }) {
        edges {
          node {
            id
            articleSettings {
              id
              slug
              title
              publishStatus
              content
              excerpt
              publishDate
            }
          }
        }
      }
    }
  `);

  return allStrapiBlogArticle.edges.map(({ node }) => node);
};

export default useStrapiBlogArticles;
